import requestIdleCallback from 'commons/requestIdleCallback';

export const LCP_FALLBACK_DELAY_MS = 8000;

/**
 * Schedules a callback for the first idle period after LCP (or after a fixed
 * delay when LCP cannot be observed). Returns a cancel function.
 */
const scheduleIdleAfterLCP = callback => {
  let scheduled = false;
  let idleFallbackTimeout = null;
  let observer = null;
  let cancelled = false;

  const schedule = () => {
    if (scheduled || cancelled) return;
    scheduled = true;
    requestIdleCallback(callback, { timeout: 5000 });
  };

  const scheduleAfterFixedDelay = () => {
    idleFallbackTimeout = setTimeout(schedule, LCP_FALLBACK_DELAY_MS);
  };

  const cancel = () => {
    cancelled = true;
    observer?.disconnect();
    if (idleFallbackTimeout) {
      clearTimeout(idleFallbackTimeout);
    }
  };

  if (typeof PerformanceObserver !== 'undefined') {
    try {
      observer = new PerformanceObserver(() => {
        observer.disconnect();
        if (idleFallbackTimeout) {
          clearTimeout(idleFallbackTimeout);
        }
        schedule();
      });
      observer.observe({ type: 'largest-contentful-paint', buffered: true });

      idleFallbackTimeout = setTimeout(() => {
        observer?.disconnect();
        schedule();
      }, LCP_FALLBACK_DELAY_MS);

      return cancel;
    } catch {
      // PerformanceObserver isn't available or doesn't support LCP in this browser.
    }
  }

  scheduleAfterFixedDelay();
  return cancel;
};

export default scheduleIdleAfterLCP;
